module.exports = __webpack_public_path__ + "img/04acc4f5633e85acd7c87c80aaeb3d2e.png";